<!-- KYMW1202 企画回別商品一覧 -->
<div class="contents-area">
  <div class="block-row">
    <div class="column-list">
      <label class="list-input-title">媒体</label>
      <div class="list-input-content">
        <app-vmedium-duties-form-type-combo-box
          #cmb_MediumType [width]="240" [(ngModel)]="model.mediumType" [orderCode]="model.orderCode" disabled>
        </app-vmedium-duties-form-type-combo-box>
      </div>
    </div>
    <div class="column-list">
      <label class="list-input-title">利用人数予測</label>
      <div class="list-input-content">
        <input type="text" [style.width.rem]="8" [ngModel]="model.publishPlanGoodsCategoryListInfo.useNumPeople | comma"
          (ngModelChange)="model.publishPlanGoodsCategoryListInfo.useNumPeople=$event" style="text-align:right;" readonly>
      </div>
    </div>
  </div>
  <div>
    <!-- アクションエリア start  -->
    <div class="action-area">
      <!-- 凡例 -->
      <label>空白：未選択、〇：通常価、△：特価１、□：特価２、☆：特価３、背景青：特集、背景緑：表紙、背景オレンジ：裏表紙</label>
      <!-- 全体行数 -->
      <label>全体行数: <span>{{model.publishPlanGoodsCategoryListInfo.totalLineNum}}</span></label>
      <!-- 中面行数 -->
      <label>中面行数: <span>{{model.publishPlanGoodsCategoryListInfo.mediumSurfaceLineNum}}</span></label>
      <!-- 大コマ -->
      <label>大コマ: <span>{{model.publishPlanGoodsCategoryListInfo.largeComaNum}}</span></label>
      <div class="element-row">
        <!-- 表示列設定 -->
        <div id="columnPicker" class="column-picker"></div>
        <!-- 列幅・表示列保存 -->
        <button class="btn-secondary" (click)="saveColumnWidthSettings()">列幅と表示列保存</button>
      </div>
      <!-- ページネーション -->
      <app-custom-pager [prevDisabled]="model.prevDisabled" [nextDisabled]="model.nextDisabled"
        [display]="model.catalogInfo.catalogId" (prevHandler)="onPrevClick()" (nextHandler)="onNextClick()">
      </app-custom-pager>
    </div>
     <!-- アクションエリア end -->
    <!-- 企画回商品別一覧 -->
    <wj-flex-grid #dtg_PlanGoodsList [itemsSource]="model.publishPlanGoodsCategoryInfo"
      [allowDragging]="'None'" horizontalScrollPolicy="'off'" [headersVisibility]="'Column'" [selectionMode]="'Row'"
      verticalScrollPolicy="'on'" [allowSorting]="false" [autoRowHeights]="true" forcedEnabledMode="true" [tabindex]="0" [frozenColumns]="7"
      style="height: calc(100vh - 368px);">
      <wj-flex-grid-filter #fltr_PlanGoodsList></wj-flex-grid-filter>
      <wj-flex-grid-column [header]="'受注コード'" [minWidth]="5" [width]="100" [binding]="'orderCode'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'配達企画回'" [minWidth]="5" [width]="104" [binding]="'catalogId'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="120" [binding]="'className'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'大分類名'" [minWidth]="5" [width]="90" [binding]="'largeClassName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'中分類名'" [minWidth]="5" [width]="100" [binding]="'middleClassName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'小分類名'" [minWidth]="5" [width]="120" [binding]="'smallClassName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'JANコード'" [minWidth]="5" [width]="130" [binding]="'janCode'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'アイテム\nコード'" [multiLine]="true" [minWidth]="5" [width]="90" [binding]="'itemCode'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'Pコード'" [minWidth]="5" [width]="90" [binding]="'pcode'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'商品名'" [minWidth]="5" [width]="215" [binding]="'goodsName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'規格名'" [minWidth]="5" [width]="200" [binding]="'goodsStandardName'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'支払先取引先'" [minWidth]="5" [width]="120" [binding]="'payeeClientKanji'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'発注先取引先'" [minWidth]="5" [width]="120"  [binding]="'ordrClientKanji'"[isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'取扱期間\n（終了）'" [multiLine]="true" [minWidth]="5" [width]="90" [binding]="'applyTermEnd'" [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'特集コード'" [minWidth]="5" [width]="150" [binding]="'specialFeature'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box
            [(ngModel)]="cell.item.specialFeature" [listSource]="model.featureCodeList"
            valueField="featureCode" labelField="featureCodeLabel" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
            [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.featureCode = ''"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !isFullControl"
            (change)="featureCode_CHANGEHandler(cell)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'ノンブル'" [minWidth]="5" [width]="80" [binding]="'folio'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="text" plessInputTextSub [restrict]="'[0-9]'" [halfOnly]="true" [maxlength]="3" [style.width.%]="'100'" [(ngModel)]="cell.item.folio" value="{{cell.item.folio}}"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !isFullControl || model.folioDisabled[cell.row.index]"
            (input)="folio_CHANGEHandler()"/>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'EDLP'" [minWidth]="5" [width]="130" [binding]="'edlp'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box
            [(ngModel)]="cell.item.edlp" [listSource]="model.edlpLabelList"
            valueField="value" labelField="label" [blank]="false" [blankVal]="''" [tabindex]="0" [visible]="true"
            [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.edlp = ''"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
            (change)="edlp_CHANGEHandler(cell)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'忘れず注文取扱'" [minWidth]="5" [width]="130" [isReadOnly]="true" [align]="'center'" [binding]="'isRememberGoods'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.isRememberGoods ? '○' : ''}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'商品メモ'" [minWidth]="5" [width]="120" [binding]="'goodsMemo'" [isReadOnly]="true"></wj-flex-grid-column>
      <!-- 取扱生協 start -->
      <wj-flex-grid-column [header]="'い'" [minWidth]="5" [width]="60" [isReadOnly]="true" [align]="'center'" [binding]="'coopEnabledFlg142'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="coopEnabledFlg142_{{cell.row.index}}" [(ngModel)]="cell.item.coopEnabledFlg142"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' ||!cell.item.coopFlg142 || !isFullControl"
              (input)="coopFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'と'" [minWidth]="5" [width]="60" [isReadOnly]="true" [align]="'center'" [binding]="'coopEnabledFlg163'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="coopEnabledFlg163_{{cell.row.index}}" [(ngModel)]="cell.item.coopEnabledFlg163"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !cell.item.coopFlg163 || !isFullControl"
              (input)="coopFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'ぐ'" [minWidth]="5" [width]="60" [isReadOnly]="true" [align]="'center'" [binding]="'coopEnabledFlg185'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="coopEnabledFlg185_{{cell.row.index}}" [(ngModel)]="cell.item.coopEnabledFlg185"
              [disabled]="!isbuyer || issupplier ||  model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !cell.item.coopFlg185 || !isFullControl"
              (input)="coopFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'ち'" [minWidth]="5" [width]="60" [isReadOnly]="true" [align]="'center'" [binding]="'coopEnabledFlg240'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="coopEnabledFlg240_{{cell.row.index}}" [(ngModel)]="cell.item.coopEnabledFlg240"
              [disabled]="!isbuyer  || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !cell.item.coopFlg240 || !isFullControl"
              (input)="coopFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'さ'" [minWidth]="5" [width]="60" [isReadOnly]="true" [align]="'center'" [binding]="'coopEnabledFlg210'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="coopEnabledFlg210_{{cell.row.index}}" [(ngModel)]="cell.item.coopEnabledFlg210"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !cell.item.coopFlg210 || !isFullControl"
              (input)="coopFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'とう'" [minWidth]="5" [width]="60" [isReadOnly]="true" [align]="'center'" [binding]="'coopEnabledFlg302'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="coopEnabledFlg302_{{cell.row.index}}" [(ngModel)]="cell.item.coopEnabledFlg302"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !cell.item.coopFlg302 || !isFullControl"
              (input)="coopFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'な'" [minWidth]="5" [width]="60" [isReadOnly]="true" [align]="'center'" [binding]="'coopEnabledFlg515'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="coopEnabledFlg515_{{cell.row.index}}" [(ngModel)]="cell.item.coopEnabledFlg515"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !cell.item.coopFlg515 || !isFullControl"
              (input)="coopFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'に'" [minWidth]="5" [width]="60" [isReadOnly]="true" [align]="'center'" [binding]="'coopEnabledFlg451'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="coopEnabledFlg451_{{cell.row.index}}" [(ngModel)]="cell.item.coopEnabledFlg451"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !cell.item.coopFlg451 || !isFullControl"
              (input)="coopFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <!-- 取扱生協 end -->
      <wj-flex-grid-column *ngIf="isbuyer" [header]="'バイヤー\nコメント'" [multiLine]="true" [minWidth]="5" [width]="200" [binding]="'buyerComment'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="text" [maxlength]="256" [style.width.%]="'100'" [(ngModel)]="cell.item.buyerComment" value="{{cell.item.buyerComment}}"
            [disabled]="model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
            (input)="buyerComment_CHANGEHandler()"
            plessInputTextSub [restrict]="'[ -￮]'" [fullOnly]="true"/>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'価格プロモーション'" [minWidth]="5" [width]="200" [binding]="'pricePromotion'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box
            [(ngModel)]="cell.item.pricePromotion" [listSource]="model.pricePromotionLabelList"
            valueField="value" labelField="label" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
            [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.pricePromotion = ''"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
            (change)="pricePromotion_CHANGEHandler(cell)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'プロモーション\nマーク'" [multiLine]="true" [minWidth]="5" [width]="180" [binding]="'promotionMark'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box
            [(ngModel)]="cell.item.promotionMark" [listSource]="model.promotionMarkLabelList"
            valueField="value" labelField="label" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
            [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.promotionMark = ''"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
            (change)="promotionMark_CHANGEHandler(cell)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'登場区分'" [minWidth]="5" [width]="180" [binding]="'appearDiv'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box
            [(ngModel)]="cell.item.appearDiv" [listSource]="model.appearDivLabelList"
            valueField="value" labelField="label" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
            [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.appearDiv = ''"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
            (change)="appearDiv_CHANGEHandler(cell)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'お買い得\n期間'" [multiLine]="true" [minWidth]="5" [width]="80" [binding]="'bargainMarkFlg'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="bargainMarkFlg_{{cell.row.index}}" [(ngModel)]="cell.item.bargainMarkFlg"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
              (input)="bargainMarkFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'コマプロ\nモーション'" [multiLine]="true" [minWidth]="5" [width]="120" [binding]="'komaPromotion'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box
            [(ngModel)]="cell.item.komaPromotion" [listSource]="model.komaPromotionLabelList"
            valueField="value" labelField="label" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
            [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.komaPromotion = ''"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
            (change)="komaPromotion_CHANGEHandler(cell)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'価格\nパターン'" [multiLine]="true" [minWidth]="5" [width]="150" [binding]="'pricePattern'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box
            [(ngModel)]="cell.item.pricePattern" [listSource]="model.pricePatternLabelList"
            valueField="value" labelField="label" [blank]="false" [blankVal]="''" [tabindex]="0" [visible]="true"
            [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.pricePattern = ''" [required]="true"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
            (change)="pricePattern_CHANGEHandler(cell)">
          </app-versatile-combo-box>
        </ng-template>
      </wj-flex-grid-column>
      
      <wj-flex-grid-column [header]="'注文コード割当'" [minWidth]="5" [width]="180" [binding]="'orderNumQuotaCode'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <app-versatile-combo-box
            *ngIf="!cell.item.wCarryingFlg" [(ngModel)]="cell.item.orderNumQuotaCode" [listSource]="model.orderNumQuotaList"
            valueField="orderNumQuotaCode" labelField="orderNumQuotaLabel" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
            [autofocus]="false" forcedEnabledMode="true" (onChangedInvalid)="cell.item.orderNumQuotaCode = ''"  [required]="true"
            [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
            (change)="orderNumQuotaCode_CHANGEHandler(cell)">
          </app-versatile-combo-box>
          <select *ngIf="cell.item.wCarryingFlg" [disabled]="'true'" [style.width.%]="100">
            <option>{{toDisplayCodeAndName(cell.item.orderNumQuotaCode, cell.item.orderNumQuotaName)}}</option>
          </select>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'W・\n媒体内'" [multiLine]="true" [isReadOnly]="true" [minWidth]="5" [width]="80" [align]="'center'" [binding]="'mediumWPublishFlg'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="mediumWPublishFlg_{{cell.row.index}}" [(ngModel)]="cell.item.mediumWPublishFlg"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
              (input)="mediumWPublishFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'クロス商品'" [minWidth]="5" [width]="250" [isReadOnly]="true" [binding]="'pCodeOfCross'"></wj-flex-grid-column>
      <wj-flex-grid-column [header]="'クロス\n設定確定'" [multiLine]="true" [isReadOnly]="true" [minWidth]="5" [width]="80" [align]="'center'" [binding]="'crossDecisionFlg'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="crossDecisionFlg_{{cell.row.index}}" [(ngModel)]="cell.item.crossDecisionFlg"
              [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg || !isFullControl"
              (input)="crossDecisionFlg_CHANGEHandler()"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'W・\nクロス'" [multiLine]="true" [isReadOnly]="true" [minWidth]="5" [width]="80" [align]="'center'" [binding]="'wCrossFlg'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>
            <input type="checkbox" id="wCrossFlg_{{cell.row.index}}" [(ngModel)]="cell.item.wCrossFlg" [disabled]="true"/>
          </div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'今回\n供給価    '" [multiLine]="true" [minWidth]="5" [width]="100" [binding]="'thisTimeSupplyPrice'" [align]="'right'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [halfOnly]="true" [style.width.%]="'100'" class="text-label-required" [(ngModel)]="cell.item.thisTimeSupplyPrice" [disabled]="!isbuyer || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || cell.item.wCarryingFlg"
            (change)="thisTimeSupplyPrice_CHANGEHandler(cell.item)" style="text-align:right;" [disabled]="issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg"/>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'今回\n仕入価    '" [multiLine]="true" [minWidth]="5" [width]="100" [binding]="'thisTimeCostPrice'" [align]="'right'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="text" plessInputTextSub [restrict]="'[.0-9]'" [maxlength]="7" [halfOnly]="true" [style.width.%]="'100'" class="text-label-required" [(ngModel)]="cell.item.thisTimeCostPrice" [disabled]="!isbuyer || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || cell.item.wCarryingFlg"
            (change)="thisTimeCostPrice_CHANGEHandler(cell.item)" style="text-align:right;" [disabled]="issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg"/>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'計画数\n(予測)    '" [multiLine]="true" [minWidth]="5" [width]="125" [isReadOnly]="true" [binding]="'planNumAiPrediction'" [align]="'right'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [align]="'right'">{{cell.item.planNumAiPrediction | comma}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'計画数\n(修正)    '" [multiLine]="true" [minWidth]="5" [width]="125" [binding]="'planNum'" [align]="'right'" [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <input type="text" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="8" [halfOnly]="true" [style.width.%]="'100'" [(ngModel)]="cell.item.planNum" [disabled]="!isbuyer || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg"
            (change)="planNum_CHANGEHandler(cell.item)" style="text-align:right;" [disabled]="issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || cell.item.wCarryingFlg"/>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'PI値'" [minWidth]="5" [width]="110" [isReadOnly]="true" [binding]="'piValue'" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [align]="'right'">{{cell.item.piValue | number:'1.2-2' | comma}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'供給高'" [minWidth]="5" [width]="110" [isReadOnly]="true" [binding]="'supplyBudget'" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [align]="'right'">{{cell.item.supplyBudget | comma}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'GP高'" [minWidth]="5" [width]="110" [isReadOnly]="true" [binding]="'gpValue'" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [align]="'right'">{{cell.item.gpValue | comma}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [header]="'GPR'" [minWidth]="5" [width]="110" [isReadOnly]="true" [binding]="'gprValue'" [align]="'right'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div [align]="'right'">{{cell.item.gprValue | number:'1.2-2'| comma | suffix:'%'}}</div>
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
  </div>
  <div>
    <!-- 予算比表 -->
    <table class="kymw1201-table" [style.width.px]="918" [style.float]="'right'">
      <tr>
        <th></th>
        <th class="planned-value-width">計画数（修正）</th>
        <th class="supply-amount-width">供給高</th>
        <th class="GP-width">GP高</th>
        <th class="GPR-width">GPR</th>
        <th class="item-width">アイテム数</th>
      </tr>
      <tr>
        <th style="width: 120px;">計画数（フィルタ）</th>
        <td class="align-right planned-value-width">{{model.filteredPlannedValuePlannedValue | comma}}</td>
        <td class="align-right supply-amount-width">{{model.filteredPlannedValueSupplyAmount | comma}}</td>
        <td class="align-right GP-width">{{model.filteredPlannedValueGP | comma}}</td>
        <td class="align-right GPR-width">{{model.filteredPlannedValueGPR | number:'1.2-2' | comma | suffix:'%'}}</td>
        <td class="align-right item-width">{{model.filteredPlannedValueItemNum}}</td>
      </tr>
      <tr>
        <th style="width: 120px;">計画数（全体）</th>
        <td class="align-right planned-value-width">{{model.plannedValuePlannedValue | comma}}</td>
        <td class="align-right supply-amount-width">{{model.plannedValueSupplyAmount | comma}}</td>
        <td class="align-right GP-width">{{model.plannedValueGP | comma}}</td>
        <td class="align-right GPR-width">{{model.plannedValueGPR | number:'1.2-2' | comma | suffix:'%'}}</td>
        <td class="align-right item-width">{{model.plannedValueItemNum}}</td>
      </tr>
      <tr>
        <th style="width: 120px;">予算値</th>
        <td class="align-right planned-value-width">{{model.publishPlanGoodsCategoryListInfo.planResult | comma}}</td>
        <td class="align-right supply-amount-width">{{model.publishPlanGoodsCategoryListInfo.supply | comma}}</td>
        <td class="align-right GP-width">{{model.publishPlanGoodsCategoryListInfo.gp | comma}}</td>
        <td class="align-right GPR-width">{{model.publishPlanGoodsCategoryListInfo.budgetValueGPR | number:'1.2-2' | comma | suffix:'%'}}</td>
        <td></td>
      </tr>
      <tr>
        <th style="width: 120px;">予算比</th>
        <td class="align-right planned-value-width">{{model.budgetRatioPlannedValue | number:'1.2-2' | comma | suffix:'%'}}</td>
        <td class="align-right supply-amount-width">{{model.budgetRatioSupplyAmount | number:'1.2-2' | comma | suffix:'%'}}</td>
        <td class="align-right GP-width">{{model.budgetRatioGP | number:'1.2-2' | comma | suffix:'%'}}</td>
        <td class="align-right GPR-width">{{model.budgetRatioGPR | number:'1.2-2' | comma | suffix:'%'}}</td>
        <td></td>
      </tr>
    </table>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-tartiary" forcedEnabledMode="none" [tabindex]="0" (click)="eventBack_CLICKHandler()">サイクル設定画面に戻る</button>
  <button class="btn-primary btn-regist-cycle" forcedEnabledMode="none" [tabindex]="0" (click)="registCycleInfo_CLICKHandler()"
    [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !isFullControl">サイクル確定</button>
  <button class="btn-secondary" forcedEnabledMode="none" [tabindex]="0" (click)="outputPublishPlanGoodsCategoryListInfo_CLICKHandler()"
    [disabled]="!isbuyer || issupplier || !isFullControl">ダウンロード</button>
  <button class="btn-secondary" forcedEnabledMode="none" [tabindex]="0" (click)="updateCycleInfo_CLICKHandler()"
    [disabled]="!isbuyer || issupplier || model.publishPlanGoodsCategoryListInfo.confirmFlg === '1' || model.catalogInfo.catalogFixFlg === '1' || !isFullControl">保存</button>
</footer>
